import { SidebarProps } from '../../../Types'
import { StateValue } from '../../Context';
import { Step, Icon } from 'semantic-ui-react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next';

const SidebarNategis = (props: SidebarProps) => {
  const state = useContext(StateValue);
  const { t } = useTranslation(state.org.theme.config.translationKey);

  return (
    <Step completed={state.current.order > props.flowItem.order} active={props.flowItem.order === state.current.order}>
      {!props.mediumScreen && <Icon name="credit card outline" className={`${props.flowItem.order > state.current.order ? "sidebar-icon-completed" : "sidebar-icon"}`} />}
      <Step.Content className="sidebar-header-cont">
        <Step.Title className="sidebar-header">{t("Nategis.Title")}</Step.Title>
        <Step.Description className="sidebar-subheader">{t("Nategis.Verify_Identity")}</Step.Description>
      </Step.Content>
    </Step>
  )
}

export default SidebarNategis
